import React, { useState, useEffect, MouseEvent } from "react";
import { Grid, Switch } from "@material-ui/core";
import css from "classnames";
import styles from "./tab-switch.module.css";

// calling preventDefault on the react synthetic event doesn't work in
// some edge cases, such as when this is used inside of a modal which is
// a child of a material-ui ClickAwayListener so calling preventDefault
// on the backing native event is a hacky workaround.

interface Props {
  id?: string;
  tabIsActive: boolean;
  switchIsOn: boolean;
  onSwitchClick: (event: MouseEvent) => void;
  onTabClick: (event: MouseEvent) => void;
  label: string;
  tabHasError?:boolean;
}

const TabSwitch: React.FC<Props> = ({
  id,
  tabIsActive,
  switchIsOn,
  onSwitchClick,
  onTabClick,
  label,
  tabHasError,
}) => {
  const [myTabIsActive, setMyTabIsActive] = useState(false);
  const onChangeTabIsActive = () => setMyTabIsActive(tabIsActive);
  useEffect(onChangeTabIsActive, [tabIsActive]);
  const [mySwitchIsOn, setMySwitchIsOn] = useState(false);
  const onChangeSwitchIsOn = () => setMySwitchIsOn(switchIsOn);
  useEffect(onChangeSwitchIsOn, [switchIsOn]);

  return (
    <Grid item sm={4} lg={3} xs={6}>
      <div
        className={css(styles.tabSwitch, {
          [styles.tabSwitchActiveBorder]: myTabIsActive,
          [styles.tabSwitchActive]: myTabIsActive && !(mySwitchIsOn && tabHasError),
          [styles.tabSwitchActiveHasError]: myTabIsActive && mySwitchIsOn && tabHasError,
          [styles.tabSwitchHasError]: !myTabIsActive && mySwitchIsOn && tabHasError,
        })}
        onClick={(event: MouseEvent) => {
          event.preventDefault();
          event.nativeEvent.preventDefault();
          setMyTabIsActive(true);
          onTabClick(event);
        }}>
        <Switch
          id={id}
          onClick={(event: MouseEvent) => {
            event.preventDefault();
            event.nativeEvent.preventDefault();

            setMySwitchIsOn(!mySwitchIsOn);
            onSwitchClick(event);
          }}
          checked={mySwitchIsOn}/>
        <div
          className={styles.tabLabel}>
          {label}
          {mySwitchIsOn && tabHasError && <span className={css("fa", "fa-warning", styles.errorIcon)}/>}
        </div>
      </div>
    </Grid>
  );
};

export default TabSwitch;
